/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  AchRecipientFilterModelDto,
  AchRecipientModelDto,
  AchRecipientRecordModelDto,
  SearchAchRecipientResponseModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AchRecipientsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags AchRecipients
   * @name AchRecipientsPostAll
   * @summary Upload recipients from file.
   * @request POST:/achRecipients
   */
  achRecipientsPostAll = (
    data: {
      /** @format binary */
      file?: File | null;
    },
    query?: {
      /** File format hint. */
      format?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AchRecipientModelDto[], any>({
      path: `/achRecipients`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AchRecipients
   * @name AchRecipientsGet
   * @summary Gets recipients.
   * @request GET:/achRecipients
   */
  achRecipientsGet = (params: RequestParams = {}) =>
    this.http.request<AchRecipientRecordModelDto[], any>({
      path: `/achRecipients`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AchRecipients
   * @name AchRecipientsPost
   * @summary Searches recipients.
   * @request POST:/achRecipients/Search
   */
  achRecipientsPost = (
    data: AchRecipientFilterModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SearchAchRecipientResponseModelDto, any>({
      path: `/achRecipients/Search`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
